import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Ows from "../../utils/OwsHandler";

interface CandidateState {
  candidate: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: CandidateState = {
  candidate: null,
  loading: false,
  error: null,
};

export const fetchCandidate = createAsyncThunk(
  "candidate/fetchCandidate", 
  async (uid: string, { rejectWithValue }) => {
  try {
    const { response } = await Ows.handleRequest("Otys.Services.CandidateService.getDetail", [
      uid,
      {
        uid: true,
        status: true,
        Person: {
          firstName: true,
          infix: true,
          lastName: true,
          AddressPrimary: {
            address: true,
            city: true,
            postcode: true,
            country: true,
          },
          PhoneNumbers: {
            phoneNumber: true, 
          },
          emailPrimary: true,
          gender: true,
        },
        profileImage: true,
        applyCount: true,
      },
    ]);

    if (response) {
      return response;
    } else {
      return rejectWithValue("No candidate found with this email.");
    }
  } catch (error: any) {
    return rejectWithValue("Failed to fetch candidate.");
  }
});

const candidateSlice = createSlice({
  name: "candidate",
  initialState,
  reducers: {
    resetCandidate: (state) => {
      state.candidate = null;
      state.loading = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCandidate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidate.fulfilled, (state, action) => {
        state.candidate = action.payload;
        state.loading = false;
      })
      .addCase(fetchCandidate.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export const { resetCandidate, clearError } = candidateSlice.actions;
export default candidateSlice.reducer;
